import { StockAllocationAPIItem, StocksAllocationItem } from '@shared/models/Strategy';

const GRAPH_COLOURS = [
  '#F9D483',
  '#F8C97A',
  '#F7BE71',
  '#F6B368',
  '#F5A85F',
  '#F49D57',
  '#F3934E',
  '#F28846',
  '#F17E3F',
  '#F17338',
  '#F06831',
  '#EF5B2C',
  '#EE3C15'
];

export function transformStocksAllocationData(data: StockAllocationAPIItem[]): StocksAllocationItem[] {
  if (!data || !data.length) return [];

  const finalData: StocksAllocationItem[] = [];

  data.forEach((item, index) => {
    finalData.push({
      id: index,
      key: Object.keys(item)[0],
      value: item[Object.keys(item)[0]],
      color: GRAPH_COLOURS[index]
    });
  });

  return finalData;
}

export function transformStocksAllocationDataEve2(data: Record<string, string>): StocksAllocationItem[] {
  const weights = Object.entries(data ?? {});
  if (weights.length === 0) return [];

  return weights.map(([key, value], index) => ({
    id: index,
    key,
    value: Number.parseFloat(value),
    color: GRAPH_COLOURS[index]
  }));
}

export function transformStocksAllocationShortlist(data: StocksAllocationItem[]) {
  if (!data || !data.length) return [];

  let totalFirstTree = 0;
  const shortList = data.filter((item, index) => {
    if (index < 3) {
      totalFirstTree += item.value;
    }
    return index < 3;
  });

  shortList.push({
    id: 4,
    color: '#F6B368',
    key: 'other',
    value: 1 - totalFirstTree
  });

  return shortList;
}
